(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './capitalize', './replace', './toLower', './toUpper'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./capitalize'), require('./replace'), require('./toLower'), require('./toUpper'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.capitalize, global.replace, global.toLower, global.toUpper);
    global.index = mod.exports;
  }
})(this, function (exports, _capitalize, _replace, _toLower, _toUpper) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.toUpper = exports.toLower = exports.replace = exports.capitalize = undefined;
  exports.capitalize = _capitalize.capitalize;
  exports.replace = _replace.replace;
  exports.toLower = _toLower.toLower;
  exports.toUpper = _toUpper.toUpper;
});